import { useState } from 'react';
import {
  DatePicker,
  Input,
  Select,
  Button,
  Table,
  Card,
  Row,
  Col,
  Space,
  Tag,
  Tooltip
} from 'antd';
import { SearchOutlined, FilterOutlined, DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { styled } from '@mui/system';
import { useSelector } from 'react-redux';
import AuthService from '../../../Components/auth/AuthService';
import { useLoadingDispatch, showLoading, hideLoading } from '../../../context/loadingContext';
import { showMessage } from '../../../Components/Utils/message';
import Papa from "papaparse";
import { netsuite_url } from '../../../Components/config';
import { useNavigate } from 'react-router-dom';
import { encodeId } from '../../../Components/common/CommonFun';

const Auth = new AuthService();

const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;

const { RangePicker } = DatePicker;
const { Option } = Select;

const StockTrail = () => {
  const { products, locations, roles } = useSelector((state) => state.AppState?.userCreds);
  const layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    dateRange: null,
    product: null,
    batchCode: '',
  });

  const columns = [
    {
      title: "Date",
      render: (record) => {
        return (
          <>
            {record?.posting_date ? dayjs(record?.posting_date).format('DD-MM-YYYY') : ""}
          </>
        )
      },
      // width: 80
    },
    {
      title: 'Document Type',
      dataIndex: 'type',
      key: 'type',
      // width: 100,
    },
   {
  title: 'Document No.',
  render: (record) => {
    const hasRole5 = roles?.some(r => r.role_id === 5);

    const getUrl = () => {
      if (record?.type === 'Sales Invoice') {
        return `${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.transaction_id}`;
      }
      if (record?.type === 'Purchase Order') {
        return `${netsuite_url}/app/accounting/transactions/purchord.nl?id=${record?.transaction_id}`;
      }
      if (record?.type === 'Credit Note') {
        return `${netsuite_url}/app/accounting/transactions/custcred.nl?id=${record?.transaction_id}`;
      }
      if (record?.type?.includes("Route")) {
        return `${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.transaction_id}`;
        }
        if (record?.type?.includes("Route")) {
        return `${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.transaction_id}`;
      }
      
      return null; // transfer cases handled separately
    };
     const isTransfer = record?.type === 'Transfer Stock';
     const isOb = record?.type === 'Opening Balance';
     const isInventory = record?.type === 'Inventory Adjustment';

    return record?.transaction_id && record?.document_number ? (
      <>
        {hasRole5 ? (
          <>{record?.document_number}</>
        ) : isTransfer ? (
          <Tooltip title="View Details" placement="top">
            <span
              onClick={() =>{
                    const hasedID = encodeId(record?.transaction_id)
                  navigate(`/transaction-transfer/${hasedID}`)
                }}
              style={{ color: "#2563eb", fontWeight: 600, cursor: "pointer" }}
            >
              {record?.document_number}
            </span>
          </Tooltip>
        ) : isOb ? (
          <Tooltip title="View Details" placement="top">
            <span
              onClick={() =>{
                    const hasedID = encodeId(record?.transaction_id)
                  navigate(`/transaction-ob/${hasedID}`)
                }}
              style={{ color: "#2563eb", fontWeight: 600, cursor: "pointer" }}
            >
              {record?.document_number}
            </span>
          </Tooltip>
        ) : isInventory ? (
          <Tooltip title="View Details" placement="top">
            <span
              onClick={() =>{
                    const hasedID = encodeId(record?.transaction_id)
                  navigate(`/transaction-inventory/${hasedID}`)
                }}
              style={{ color: "#2563eb", fontWeight: 600, cursor: "pointer" }}
            >
              {record?.document_number}
            </span>
          </Tooltip>
        ) : (
          <Tooltip title="View Details" placement="top">
            <a
              href={getUrl()}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2563eb", fontWeight: 600 }}
            >
              {record?.document_number}
            </a>
          </Tooltip>
        )}
      </>
    ) : (
      "-"
    );
  },
  // width: 90,
},


    {
      title: "Entity",
      render: (record) => {
        return (
          <>
            {record?.code ? `${record?.code} - ${record?.name}` : ""}
          </>
        )
      },
      // width: 100
    },
    {
      title: 'Product',
      render: (record) => {
        const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
        return (
          <>
            {selected?.code ? `${selected?.code} - ${selected?.name}` : ""}
          </>
        );
      },
      // width: 60
    },
    {
      title: 'Location',
      render: (record) => {
        const selected = locations?.find((item) => item.id == record?.location_id)
        return (
          <>
            {selected?.code}
          </>
        );
      },
      // width: 60
    },

    {
      title: 'Quantity',
      render: (record) => {
        const quantity = Number(record?.quantity) || 0;
        const color = quantity > 0 ? 'green' : 'red';
        return (
          <Tag color={color} style={{ fontWeight: 'bold' }}>
            {quantity}
          </Tag>
        );
      },
      align: 'center',
      // width: 100
    },
    {
      title: "Batch Code",
      render: (record) => {
        return (
          <>
            {record?.batch_code ? record?.batch_code : ""}
          </>
        )
      },
      // width: 100
    },
    {
      title: "Supplier Batch Code",
      render: (record) => {
        return (
          <>
            {record?.supplier_batch_code ? record?.supplier_batch_code : ""}
          </>
        )
      },
      // width: 120
    },
    {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },

    {
      title: "Created At",
      render: (record) => {
        return (
          <>
            {record?.createdAt ? dayjs(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : ""}
          </>
        )
      },
      // width: 120
    },
    {
  title: "User",
  render(record) {
    if (!record) return "";

    const user = record?.user_name || "";
    const helper = record?.helper_name || "";

    if (helper) {
      return (
        <>
          {helper}{" "}
          {user && (
            <Tooltip title={`${user}`}>
              <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
            </Tooltip>
          )}
        </>
      );
    }

    return <>{user}</>;
  },
  // width: 90
},
  ];

  const handleSearch = async () => {
    console.log('Filters:', filters);
    const [start, end] = filters.dateRange || [];

     // ✅ Check: At least one filter must be present
  if (!filters.product && !filters.batchCode && (!start || !end)) {
    showMessage("error", "Please select at least one filter (Date Range, Product, or Batch Code)");
    return;
  }

  // ✅ Check: If only dateRange selected, it must be valid
  if ((start && !end) || (!start && end)) {
    showMessage("error", "Please select a complete date range");
    return;
  }
   
    const payload = {};
  if (filters.product) payload.id = filters.product;
  if (filters.batchCode) payload.supplier_batch_code = filters.batchCode;
  if (start && end) {
    payload.start_date = dayjs(start).format("YYYY-MM-DD");
    payload.end_date = dayjs(end).format("YYYY-MM-DD");
  }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/report/stock-trail`, {
        method: "POST",
        body: JSON.stringify(payload),
      })
      if (res?.ack) {
        setData(res?.stock_trail);
        if (res?.stock_trail.length > 0) {
        } else {
          setData([]);
          showMessage('error', 'No data found')
        }
      } else {
        setData([]);
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }

    console.log("Payload:", payload);
  };

  const handleReset = () => {
    setFilters({
      dateRange: null,
      product: null,
      batchCode: '',
    });
    setData([]);
  };

  const handleExportCSV = () => {
    if (!data || data.length === 0) {
      showMessage("error", "No data to export");
      return;
    }

    // Define headers from table columns
    const headers = columns.map(col => col.title);

    // Map data into rows
    const rows = data.map(record =>
      columns.map(col => {
        if (col.dataIndex) {
          return record[col.dataIndex] ?? "";
        } else if (col.title === "Document No.") {
        return record?.document_number ?? "";
      } else if (col.render) {
          // Call render if it’s a function
          const rendered = col.render(record);
          if (typeof rendered === "string" || typeof rendered === "number") {
            return rendered;
          }
          if (rendered?.props?.children) {
            return Array.isArray(rendered.props.children)
              ? rendered.props.children.join(" ")
              : rendered.props.children;
          }
          return "";
        }
        return "";
      })
    );

    // Convert to CSV with PapaParse
    const csv = Papa.unparse({
      fields: headers,
      data: rows,
    });

    // Trigger browser download
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const selectedProduct = products.find(p => p.netsuite_id === filters.product);
    const todayDate = dayjs().format('DD-MM-YYYY');
    link.setAttribute("download", `Stock_Trail_${todayDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <DataSheet>


      {/* Search Form */}
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Stock Trail</>} style={{ marginBottom: '10px' }}>
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
            <RangePicker
              style={{ width: '100%' }}
              value={filters.dateRange}
              onChange={(dates) => setFilters(prev => ({ ...prev, dateRange: dates }))}
              format="DD-MM-YYYY"
            />
          </Col>

          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Product</label>
            <Select
              style={{ width: '100%' }}
              placeholder="Product"
              allowClear
              showSearch
              value={filters.product}
              onChange={(value) => setFilters(prev => ({ ...prev, product: value }))}
              optionFilterProp="children"
            >
              {products.map(product => (
                <Option key={product?.netsuite_id} value={product?.netsuite_id}>{`${product?.code} - ${product?.name}`}</Option>
              ))}
            </Select>
          </Col>

          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Supplier Batch Code</label>
            <Input
              placeholder="Supplier batch code"
              value={filters.batchCode}
              onChange={(e) => setFilters(prev => ({ ...prev, batchCode: e.target.value }))}
            />
          </Col>


          <Col xs={24} md={12} lg={6}>
            <Space style={{ width: '100%', marginTop: '25px' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Search
              </Button>
              {/* <Button onClick={handleReset}>
                Reset
              </Button> */}
            </Space>
          </Col>

        </Row>
      </Card>

      {/* Results Table */}
      {data.length > 0 && (
        <Card
          title={
            <span style={{ fontSize: 13, fontWeight: 600 }}>
      Search Results ({data.length} items)
    </span>
          }
          extra={
            <Button icon={<DownloadOutlined />} type="default" onClick={handleExportCSV}>

              Export
            </Button>
          }
        >
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={false}
            bordered
            scroll={{ x: 'max-content' }}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
            // size="large"
          />
        </Card>
      )}
    </DataSheet>
  );
};

export default StockTrail;